module.exports = __webpack_public_path__ + "static/media/test.32d7805f.png";